import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime,
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import React, {useEffect, useState} from "react";
import RaikoCardInfoTypeTwo from "../../raikoComponents/raikoCardInfoTypeTwo/RaikoCardInfoTypeTwo";
import {css} from "@emotion/css";
import {UsersAvatarService} from "../../serverService/usersAvatarService/UsersAvatarService";
import avatar from "../../assets/images/avatar.svg"
import AddNewPredefinedAvatar from "../../component/addNewPredefinedAvatar/AddNewPredefinedAvatar";
import {useNavigate} from "react-router-dom";

export default function UsersAvatar() {

    let page = 0
    const size = 30

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [usersAvatarListData, setUsersAvatarListData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);


    const service = new UsersAvatarService();

    useEffect(() => {
        getUsersAvatarListFromSever()
    }, []);


    function getUsersAvatarListFromSever() {
        setTableLoading(true)
        service.getUsersAvatarList(page, size).then(
            response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setUsersAvatarListData([])
                response.data.map((item, index) => {
                    setUsersAvatarListData(prevState => [
                        ...prevState,
                        usersAvatarTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.image && item.image.downloadUrl ? item.image.downloadUrl.replace("http://", "https://") : avatar,
                            item.title,
                            item.slug,
                            item.createdBy,
                            item.createdAt
                        )

                    ])
                })
            }
        ).catch(reason => {
            showServerErrorMessage(reason)
            console.log("reason is here:", reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    const [openAddNewAvatarDialog, setOpenAddNewAvatarDialog] = useState(false)

    function handleOpenAddNewAvatarDialog() {
        setOpenAddNewAvatarDialog(true)
    }

    function handleCloseAddNewAvatarDialog() {
        setOpenAddNewAvatarDialog(false)
    }

    const navigate = useNavigate()


    function showPredefinedAvatarDetails(avatarId) {
        let title = ""
        usersAvatarListData.map((item) => {
            if (item.id === avatarId) {
                title = item.title
            }
        })
        navigate(RouteHelper.PredefinedAvatarDetails.globalUrl.replace(":id", avatarId),
            {state: {title: title}, replace: false}
        )
    }

    function handleAddNewAvatarToTable(item) {
        const _item = addNewRowToTable(
            usersAvatarTablePreparation(
                item.id,
                1,
                item.image && item.image.downloadUrl ? item.image.downloadUrl.replace("http://", "https://") : avatar,
                item.title,
                item.slug,
                item.createdBy,
                item.createdAt
            ), usersAvatarListData
        );
        setUsersAvatarListData(_item)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.UsersAvatar.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseAddNewAvatarDialog}
                open={openAddNewAvatarDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewPredefinedAvatar handleAddNewItem={handleAddNewAvatarToTable}
                                        handleCloseAddNewAvatarDialog={handleCloseAddNewAvatarDialog}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.UsersAvatar.name,
                            ""
                        ),
                    ]}/>
                    <RaikoBaseCardContainer className={css`gap: 1.5rem;`}>
                        <RaikoTableTitleContainer
                            title={"آواتار"}
                            amount={numberOfItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenAddNewAvatarDialog}
                            hasSelectDisplayType
                            selectDisplayType={selectDisplayType}
                            setSelectDisplayType={setSelectDisplayType}
                        />
                        <RaikoCustomTable
                            header={usersTableHeader}
                            data={usersAvatarListData}
                            pageCount={pageCount}
                            isLoading={tableLoading}
                            selectDisplayType={selectDisplayType}
                            rowClicked={showPredefinedAvatarDetails}
                        >
                            <div className={css`
                                display: grid;
                                grid-template-columns: repeat(6, 1fr);
                                gap: 1rem;
                                @media screen and (max-width: 1024px) {
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    overflow-x: hidden;
                                    gap: .5rem;
                                }
                                @media screen and (max-width: 900px) {
                                    display: grid;
                                    grid-template-columns: repeat(3, 1fr);
                                    overflow-x: hidden;
                                    gap: .5rem;
                                }
                                @media screen and (max-width: 425px) {
                                    display: grid;
                                    grid-template-columns: 1fr 1fr;
                                    overflow-x: hidden;
                                }
                                @media screen and (max-width: 374px) {
                                    display: grid;
                                    grid-template-columns: 1fr;
                                    overflow-x: hidden;
                                }
                            `}>
                                {
                                    usersAvatarListData.map((item, index) => {
                                        return <RaikoCardInfoTypeTwo
                                            key={index}
                                            title={item.title}
                                            subTitle={item.createAt}
                                            id={item.id}
                                            photo={item.avatar}
                                            status={false}
                                            onClick={_ => {
                                                showPredefinedAvatarDetails(item.id)
                                            }}
                                        />
                                    })
                                }

                            </div>

                        </RaikoCustomTable>

                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

function usersAvatarTablePreparation(id, number, image, title, slug, createdBy, createAt) {
    return {
        id,
        number,
        avatar: image,
        image: <img
            src={image}
            className={css`
                border-radius: 8px;
                width: 50px;
                height: 50px;
                aspect-ratio: 1/1;
                object-fit: cover;
            `
            }
            alt=""/>,
        title,
        slug,
        createdBy,
        createAt: convertUniversalDateTimeToPersianDateTime(createAt)
    }

}

const usersTableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "image",
        label: "تصویر شهید"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "slug",
        label: "slug"
    }, {
        id: "createdBy",
        label: "سازنده"
    }, {
        id: "createAt",
        label: "تاریخ ساخت"
    },
]